import Echarts from "echarts";
const X = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
const getChartLine = (data, update, isOnResize) => {
    const { title, dataX = X, dataY, id } = data;

    // 基于准备好的dom，初始化echarts实例
    var myChart = Echarts.init(document.getElementById(id));

    myChart.resize();
    if (isOnResize) {
        return
    }

    if (update) {
        // 填入数据
        myChart.setOption({
            legend: {
                data: dataY.map(x => x.title),
            },
            xAxis: {
                data: dataX
            },
            series: dataY.map(x => ({
                name: x.title, data: x.data, type: 'line',
                symbol: 'circle',
                itemStyle: {
                    normal: {
                        lineStyle: {
                            width: 1.2
                        }
                    }
                },
            }))
        });
        return
    }

    const option = {
        color: ['#327AB7', '#4AC18E', '#D9534F', '#67A8E4'],
        tooltip: {
            trigger: 'axis',
            //formatter: "{b} <br> 合格率: {c}%"
        },
        legend: {
            data: [title],
            align: 'left',
            textStyle: {
                color: 'rgba(102, 102, 102, 1)',
                padding: [0, 0, 0, 16]
            }
        },
        grid: {
            top: '12%',
            bottom: '6%',
            left: '3%',
            right: '6%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            name: '',
            boundaryGap: false,
            axisLine: {
                show: false,
                lineStyle: {
                    color: '#525252',
                },

            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#525252'
            },
            data: dataX
        },
        yAxis: {
            type: 'value',
            name: '',
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#525252'
            },
            splitLine: {
                lineStyle: {
                    type: 'dotted',
                    color: '#AAA'//F3F3F3	
                }
            }
        },
        series: dataY.map(x => ({
            name: title,
            type: 'line',
            symbol: 'circle',
            itemStyle: {
                normal: {
                    lineStyle: {
                        width: 1.2// 0.1的线条是非常细的了
                    }
                }
            },
            data: x.data
        }))
    };

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
}


export default getChartLine;


// WEBPACK FOOTER //
// ./src/components/BI/home/getChartLine.js